import { ENV_VARS } from '@/clients/util/env';
import { serviceWorkerManager } from '@/clients/util/service-worker';
import { useEffectOnce } from '@custom-react-hooks/use-effect-once';
import { Outlet } from 'react-router-dom';
import { Screen } from '../components/Screen';
// import './program-styles.css';

export function ProgramTemplate() {
  useEffectOnce(() => {
    if (ENV_VARS.DEV) serviceWorkerManager.register();
  });
  return (
    <Screen>
      <Outlet />
    </Screen>
  );
}
